/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  SelectInput,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage, pushCountry } from "../../lib/index";
import { useCountryContext } from "../../context/CountryContext";
import { useTourPackageContext } from "../../context/TourPackageContext";
import { useAgentContext } from "../../context/AgentContext";
import { getOneAgent } from "../../lib/sysNavigation/SysNavigation";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../doseeData/utils/Utils";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { countriesList } from "../components/data";
import { FiBriefcase, FiImage, FiUser, FiCreditCard } from "react-icons/fi";

const Edit = () => {
  const { updateAgent, updateAgentState } = useAgentContext();
  const { countries, fetchCountries } = useCountryContext();
  const { tourPackages, fetchTourPackages } = useTourPackageContext();

  const _agent_ = getOneAgent();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const dsa_agents_id = _agent_.dsa_agents_id;

  const [title, setTitle] = useState(_agent_.name);
  const [country_name, setCountryName] = useState(_agent_.country);
  const [agent_package_id, setAgentPackageId] = useState(
    _agent_.agent_package_id,
  );
  const [agent_payment_id, setAgentPaymentId] = useState(
    _agent_.agent_payment_id,
  );
  const [agent_email, setAgentEmail] = useState(_agent_.email_address);
  const [agent_phone, setAgentPhone] = useState(_agent_.phonenumber);
  const [agent_contact, setAgentContact] = useState(
    _agent_.contact_person_name,
  );
  const [agent_transactions, setAgentTransactions] = useState(
    _agent_.number_of_transaction,
  );
  const [agent_rating, setAgentRating] = useState(_agent_.rating);
  const [description, setDescription] = useState(_agent_.description);

  const [thumbnail, setThumbnail] = useState(_agent_?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(_agent_?.image_cdn_id);
  const [thumbnailLogo, setThumbnailLogo] = useState(_agent_?.logo);
  const [thumbnailIdLogo, setThumbnailIdLogo] = useState(_agent_?.logo_ref_id);

  const [tourName, setTourName] = useState<any>(null);

  const agentRoutes = "/agent";

  useEffect(() => {
    if (!countries) fetchCountries();
    if (!tourPackages) fetchTourPackages();
    if (!tourName && tourPackages && agent_package_id) {
      setTourName(
        tourPackages.find(
          (x: any) => (x.tour_package_id = agent_package_id),
        )?.title,
      );
    }
  }, [countries, tourPackages, _agent_, tourName]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, message: any) => {
    setLoading(false);
    setError(isError);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const addOneAgentHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId || !thumbnailLogo || !thumbnailIdLogo) {
      setLoading(false);
      return responses(true, "Image or Logo Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      agent_package_id: agent_package_id,
      agent_payment_id: agent_payment_id,
      agent_biz_reg_no: title?.replace(/ /g, "-") || "reg-no-agent",
      logo: thumbnailLogo ? thumbnailLogo : defaultImage,
      logo_ref_id: thumbnailIdLogo,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      email_address: agent_email,
      phonenumber: agent_phone,
      contact_person_name: agent_contact,
      country: country_name ? country_name : "Uganda",
      number_of_transaction: agent_transactions,
      rating: agent_rating,
      name: title,
      description: description,
    };

    const response = await updateAgent(dsa_agents_id, data);
    if (response) {
      if (response.data.status === codeOk) {
        updateAgentState({ dsa_agents_id, ...data });
        cleanFields();
        return responses(false, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={agentRoutes}
      eyebrow="Marketplace • Agents"
      title="Edit Agent"
      subtitle="Updated brand assets, contact details and tour package information."
      icon={<FiBriefcase className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={addOneAgentHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Brand Assets"
        hint="Update an agent profile photo and an official logo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Agent Profile
            </p>
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
            />
          </div>
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Agent Logo
            </p>
            <ImageKitUpload
              thumbnail={thumbnailLogo}
              thumbnailId={thumbnailIdLogo}
              setThumbnail={setThumbnailLogo}
              setThumbnailId={setThumbnailIdLogo}
              folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
            />
          </div>
        </div>
      </AddSection>

      <AddSection
        title="Country, Phone & Packages"
        hint="Select where the agent operates and which packages they sell."
        icon={<FiCreditCard className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <SelectInput
            title="Country"
            defaultValue={country_name ? country_name : null}
            required={true}
            value={country_name ? country_name : null}
            options={countries ? countries?.map((x: any) => x?.name) : []}
            onChange={(e: any) => {
              setCountryName(e.target.value);

              const pickedCountry = countriesList?.find(
                (_c: any) =>
                  String(_c.name).toLowerCase() ===
                  String(e.target.value).toLowerCase(),
              );

              pushCountry({
                country: {
                  id: pickedCountry?.id,
                  name: pickedCountry?.name,
                  slug: pickedCountry?.name,
                  route: "/admin",
                },
              });
            }}
          />
          <PhoneInput
            phone={agent_phone}
            required={true}
            setPhone={setAgentPhone}
            country={country_name ? country_name : ""}
          />
          <Select
            props={{
              id: "tour_package_id",
              title: "Tour Package",
              option:
                tourPackages !== null
                  ? [...tourPackages.map((tour: any) => tour.title)]
                  : [],
              onChange: (e: any) => {
                const index = e.target.selectedIndex;
                setAgentPackageId(tourPackages[index]?.tour_package_id);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "agent_payment_id",
              title: "Payment Method",
              option: ["Visa", "Cash", "E-Wallet", "Mobile Money"],
              onChange: (e: any) => {
                const index = e.target.selectedIndex;
                setAgentPaymentId(index);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Agent Details"
        hint="Identity, contact person and quick metrics."
        icon={<FiUser className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_email",
              title: "Agent Email",
              type: "text",
              value: agent_email ? agent_email : "",
              onChange: (e: any) => {
                setAgentEmail(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_contact",
              title: "Agent Contact Person",
              type: "text",
              value: agent_contact ? agent_contact : "",
              onChange: (e: any) => {
                setAgentContact(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_transaction",
              title: "Agent Transactions",
              type: "number",
              value: agent_transactions ? agent_transactions : "",
              onChange: (e: any) => {
                setAgentTransactions(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_rating",
              title: "Agent Rating",
              type: "number",
              value: agent_rating ? agent_rating : "",
              onChange: (e: any) => {
                setAgentRating(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="A brief overview shown on the agent profile."
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
